export default "__VITE_ASSET__2c62a847__"